import React from 'react';
import { STEP_NAMES, TOTAL_STEPS } from '@/constants/broker-registration.constants';

interface StepIndicatorProps {
  currentStep: number;
  onStepClick: (step: number) => void;
}

export function StepIndicator({ currentStep, onStepClick }: StepIndicatorProps) {
  return (
    <div className="flex justify-between gap-3 mb-10">
      {Array.from({ length: TOTAL_STEPS }, (_, i) => i + 1).map((step) => {
        const isActive = step === currentStep;
        const isCompleted = step < currentStep;
        const isPending = step > currentStep;

        let bgClass = 'bg-gray-700';
        if (isActive) bgClass = 'bg-indigo-500';
        if (isCompleted) bgClass = 'bg-emerald-500';

        return (
          <div
            key={step}
            id={`step-${step}-indicator`}
            className={`step-indicator flex-1 py-3 px-2 rounded-lg text-center font-bold cursor-pointer transition-all duration-300 ${bgClass} text-white hover:opacity-90`}
            onClick={() => onStepClick(step)}
          >
            {step}.{' '}
            <span className={`step-text ${isActive || isCompleted ? 'inline' : 'hidden'}`}>
              {STEP_NAMES[step - 1]}
            </span>
          </div>
        );
      })}
    </div>
  );
}
